<template>
  <a-tag v-if="data[status]" :color="data[status].color">
    {{data[status].text}}
  </a-tag>
</template>

<script>
  import { statusData } from '@/constants/project'
  export default {
    name: 'ProjectStatus',
    props:{
      status:{
        type:String,
        default:'',
      }
    },
    data(){
      return {
        data:statusData
      }
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>